export const SET_TOKEN          = 'SET_TOKEN';
export const SET_USER           = 'SET_USER';
export const SET_USER_DATA      = 'SET_USER_DATA';
export const SET_REMEMBER_ME    = 'SET_REMEMBER_ME';
export const CLEAR_TOKEN        = 'CLEAR_TOKEN';
export const CLEAR_USER         = 'CLEAR_USER';
export const CLEAR_REMEMBER_ME  = 'CLEAR_REMEMBER_ME';
